import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { CommitteeMeetingSearchDto } from '../../shared/dto/committee-meeting-search.dto';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';

@Component({
  selector: 'wl-committee-meetings',
  templateUrl: './committee-meetings.component.html',
  styleUrls: ['./committee-meetings.component.less'],
    standalone: false
})
export class CommitteeMeetingsComponent implements OnInit, OnChanges {
  @Input() committeeId: number;
  searchParams: CommitteeMeetingSearchDto;

  constructor(public securityElementNames: SecurityElementNames) {
    this.searchParams = new CommitteeMeetingSearchDto();
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.committeeId && this.committeeId) {
      this.searchParams.CommitteeID = this.committeeId;
    }
  }

  ngOnInit(): void {}
}
